// src/App.js  (GÜNCELLE — import ve useEffect çağrısı)
import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Projects from "./pages/Projects";
import Fleet from "./pages/Fleet";
import FleetDetail from "./pages/FleetDetail";
import Gallery from "./pages/Gallery";
import Catalog from "./pages/Catalog";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Seo from "./components/Seo";
// ⬇⬇⬇ isim burada da güncellendi
import { parseLocation, listenLocationChange } from "./router";
import Policies from "./pages/Policies";
import About from "./pages/About";
export default function App() {
  const [{ path, params }, setState] = useState(parseLocation());

  useEffect(() => {
    const cleanup = listenLocationChange(setState);
    return cleanup;
  }, []);

  const seoMap = {
    "/": { title: "Bağcı Hafriyat | Profesyonel Hafriyat & İş Makineleri", description: "Hafriyat, kazı, yıkım ve dolgu süreçlerinde güvenilir çözüm ortağınız.", path: "/" },
    "/services": { title: "Hizmetlerimiz | Bağcı Hafriyat", description: "Kazı & dolgu, yıkım, nakliye, kanal açma, zemin iyileştirme.", path: "/services" },
    "/services/:key": { title: "Hizmet Detayı | Bağcı Hafriyat", description: "Seçilen hizmetin kapsamı ve öne çıkan özellikler.", path: `/services/${params?.key || ""}` },
    "/projects": { title: "Referanslar | Bağcı Hafriyat", description: "Geçmiş projelerden seçkiler.", path: "/projects" },
    "/fleet": { title: "Araç Parkuru | Bağcı Hafriyat", description: "İş makineleri ve kamyonlar.", path: "/fleet" },
    "/fleet/:id": { title: "Araç Detayı | Bağcı Hafriyat", description: "Seçili araç için özellikler ve kiralama bilgisi.", path: `/fleet/${params?.id || ""}` },
    "/gallery": { title: "Galeri | Bağcı Hafriyat", description: "İş sahası, makine ve proje görselleri.", path: "/gallery" },
    "/catalog": { title: "Katalog / Dokümanlar | Bağcı Hafriyat", description: "Görsel önizleme + tek tıkla indir.", path: "/catalog" },
    "/contact": { title: "İletişim | Bağcı Hafriyat", description: "Adres, iletişim bilgileri ve teklif/mesaj formu.", path: "/contact" },
    "/404": { title: "404 | Sayfa Bulunamadı", description: "Aradığınız sayfa bulunamadı.", path: "/404", robots: "noindex,nofollow" },
    "/about": { title: "Hakkımızda | Bağcı İnşaat Hafriyat", description: "Tarihçemiz, vizyonumuz, misyonumuz ve ekibimiz.", path: "#/about" },
    "/policies": { title: "Politikalar | Bağcı İnşaat Hafriyat", description: "İSG, Çevre ve İnsan Kaynakları politikalarımız.", path: "#/policies" }
  };

  const seo = seoMap[path] || seoMap["/404"];

  return (
    <div className="app">
      <Seo {...seo} />
      <Header currentRoute={path} />
      <main className="main" id="main-content" tabIndex="-1">
        {path === "/" && <Home />}
        {path === "/services" && <Services />}
        {path === "/services/:key" && <ServiceDetail keyParam={params.key} />}
        {path === "/projects" && <Projects />}
        {path === "/fleet" && <Fleet />}
        {path === "/fleet/:id" && <FleetDetail id={params.id} />}
        {path === "/gallery" && <Gallery />}
        {path === "/catalog" && <Catalog />}
        {path === "/contact" && <Contact />}
        {path === "/about" && <About />}
        {path === "/policies" && <Policies />}
        {path === "/404" && <NotFound />}
      </main>
      <Footer />
    </div>
  );
}